import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Product from '../../components/product/Product';

class TopProducts extends React.Component {

    state = {
        topProducts: null
    }

    componentDidMount() {
        this.setState({
            topProducts: appSettingsTopProducts.topProducts
        });
    }

    render() {
        const {props: {basket: {items, totalPrice}}, state: {topProducts}} = this;

        if (topProducts === null) {
            return null;
        }
        
        

        return (
                <React.Fragment>
                    {topProducts && topProducts.map(sector => {
                        return (
                            <React.Fragment key={sector.sectorName}>
                                <h2><a href={sector.sectorUrl}>{sector.sectorName}</a></h2>
                                <ul className="product-list">
                                    {sector.products.map(product => {

                                        const basketItemArr = items.filter(i => i.catalogNumber === product.catalogNumber);
                                        const qty = basketItemArr.length > 0 ? basketItemArr[0].qty : 0;

                                        return <Product key={product.id} qty={qty} product={product} />;
                                    })}
                                </ul>
                                <p className="text-right">
                                <a className="btn btn-basket plus" href={sector.sectorUrl}> Zobraziť všetko z katalógu</a>
                                </p>        
                            </React.Fragment>    
                        );
                    })}
                </React.Fragment>  
        );
    }
}

const mapStateToProps = (state) => ({
    basket: state.basket
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TopProducts);